import React from "react";
import ScheduleFlag from "./ScheduleFlag";

const InProgressFlag = () => (
  <ScheduleFlag text="In Progress" color="#009E36" />
);

export default InProgressFlag;
